import { consoleLog } from './utils';
import { BASE_URL } from './endpoints';

// const getApiEndpoint = url => {
//   if (url?.includes('https:')) {
//     return url;
//   }
//   let _url = BASE_URL + url;
//   _url = _url.replace('/v6/api//v6/api/', '/v6/api/');
//    _url = _url.replace('/v6/api/', '/webapis/api/');
//   consoleLog('_url', url);
//   return _url;
// };

const getApiEndpoint = (url, domain) => {
  if (url?.includes('https:')) {
    return url;
  }else if(domain === 'cdr'){
    let _url = BASE_URL + url;
    _url = _url.replace('/v6/api//v6/api/', '/v6/api/');
    _url = _url.replace('/v6/api/', '/cdrapis/api/');
   consoleLog('_url', url);
   return _url;
  }else if(domain === 'paci'){
    let _url = BASE_URL + url;
    _url = _url.replace('/v6/api//v6/api/', '/v6/api/');
    _url = _url.replace('/v6/api/', '/paciapis/api/');
   consoleLog('_url', url);
   return _url;
  }
  else{
  let _url = BASE_URL + url;
  _url = _url.replace('/v6/api//v6/api/', '/v6/api/');
   _url = _url.replace('/v6/api/', '/webapis/api/');
  consoleLog('_url', url);
  return _url;
  }
};

export { BASE_URL, getApiEndpoint };
 
 
// AsyncStorage key's
export const SMARTLOGIN = 'SMARTLOGIN';
export const IS_LOGGED_IN = 'isLoggedIn';
export const TOKEN_ID = 'tokenid';
export const SELECTED_LANG = 'selectedLang';
export const CHILDMSISDN = 'childMSISDN';
export const LOGIN_TYPE = 'loginType';
export const SOCIAL_PROFILE_PIC = 'socialProfilepic';
export const SOCIAL_ID_KEY = 'socialidkey';
export const HIDE_ROAMING_POPUP = 'hideRoamingPopup';
export const STATUSBAR_COLOR = 'splashStatusBarColor';
export const NO_THANKS = 'nothanks';
export const PUSH_REGISTER = 'pushregister';
export const TOKEN_TIME = 'tokentime';
export const SELECTED_MSISDN = 'selectedMSISDN';
export const CUSTOMER_PROFILE = 'customerprofile';
export const RATE_PLAN_TYPE = 'rateplantype';
export const IS_INTERNAL_REDIRECT = 'isinternalredirect';
export const APP_INSTALLED = 'appinstalled';
export const IS_RELOAD_SLIDER = 'IS_RELOAD_SLIDER';
export const DO_NOT_SHOW_FIFA_INSTANT = 'DO_NOT_SHOW_FIFA_INSTANT';
export const MOBILEID_TIMER_STATUS = 'mobileidtimerstatus';
export const DEVICE_UNQUIE_ID = 'deviceunqueid';
export const IS_BACK_CLICKED = 'isBack';
export const IS_2FA_DONE = 'isverified2fa';
export const AUTH_KEY = 'authkey'
export const SHOW_ALERT_KEY = 'salert'

//Sim status
export const PHYSICAL = 'PHYSICAL';
export const READY_TO_ACTIVATE = 'READY_TO_ACTIVATE';
export const ALREADY_ACTIVATE = 'ALREADY_ACTIVATE';
export const ESIM_TO_ESIM = 'ESIM_TO_ESIM';
export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';
//eslint-disable-next-line
export const CONST_REGEX_NAME = /[`~0-9!₹@#$%^€£¥&*₹₩°○●□■♤♡◇♧☆▪︎¤¢™¦©¶¬¶¶§§§®©《》¡¿•×÷()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g;
//eslint-disable-next-line
export const CONST_REGEX_ADDRESS = /[`!@#₹$%^€£¥&*₹₩°○●□■♤♡◇♧☆▪︎¤¢™¦©¶¬¶¶§§§《》¡¿•×÷()_|+\=?;:'",.<>\{\}\[\]\\\/]/g;
//eslint-disable-next-line
export const CONST_REGEX_MOBILE = /[`~!₹@#$%^€£¥&*₹₩°○●□■♤♡◇♧☆▪︎¤¢™¦©¶¬¶¶§§§®©《》¡¿•×÷()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g;
//eslint-disable-next-line
export const CONST_REGEX_EMAIL_ADDRESS =  /[`!#₹$%^€£¥&*₹₩°○●□■♤♡◇♧☆▪︎¤¢™¦©¶¬¶¶§§§《》¡¿•×÷()|+\=?;:'",<>\{\}\[\]\\\/]/g;
//eslint-disable-next-line
export const CONST_REGEX_AMOUNT = /[`~!₹@#$%^€£¥&*₹₩°○●□■♤♡◇♧☆▪︎¤¢™¦©¶¬¶¶§§§®©《》a-zA-Z ¡¿•×÷()_|+\-=?;:'",<>\{\}\[\]\\\/]/g;
export const CONST_REGEX_FAQ = /[<>'"\u2018\u2019\u201C\u201D]/g;
export const CONST_REGEX_MOBILE_NO_CHAR = /[`~!₹@#$%^€£¥&*₹₩°○●□■♤♡◇♧☆▪︎¤¢™¦©¶¬¶¶§§§®©《》¡¿•×÷()_|+\-=?;:'",.<>\{\}\[\]\\\/A-Za-z ]/g;
export const CONST_REGX_DIGIT_ONLY = /[`~!₹@#$%^€£¥&*₹₩°○●□■♤♡◇♧☆▪︎¤¢™¦©¶¬¶¶§§§®©《》¡¿•×÷()_|+\-=?;:'",.<>\{\}\[\]\\\/A-Za-z ]/g

export const NOJOOM_STATUS_COLORS = {
  RED: '#ed1c24',
  SILVER: '#959595',
  GOLD: '#C7A856',
  NOKHBA: '#221E20',
  "AL NOKHBA": '#221E20',
}
export const  Months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]
export const MAX_NAME_LENGTH = 30;
export const MOBILE_NUMBER_LENGTH_8 = 8;

export const DISABLE_BALANCE_PAYMENT_METHOD = false;
export const SHOW_EXCLUSIVE_FOR_BALANCE_OR_ADD_TO_BILL_PAYMENT_METHOD = true;

export const MAKE_SMART_PAY_EXCLUSIVE = process.env.REACT_APP_MAKE_SMART_PAY_EXCLUSIVE;
export const MAKE_NOJOOM_HOT_DELAS_EXCLUSIVE = true;

export const FIXED_HEADER_BG = '#fff';